const i18n = require('common/hbs-helpers/__')
import store from '../store'


function getNewStateObj() {
   return {
      journey: {
         'default': [
            {
               index: 0,
               journey: 'default',
               title: i18n('label:select-course title'),
               name: 'select-course',
               enabled: true,
               completed: false,
            },
            {
               index: 1,
               journey: 'default',
               title: i18n('label:set-preference title'),
               name: 'set-preference',
               enabled: false,
               completed: false,
            },
            {
               index: 2,
               journey: 'default',
               title: i18n('label:select-units title'),
               name: 'select-units',
               enabled: false,
               completed: false,
            },
            {
               index: 3,
               journey: 'default',
               title: i18n('label:course-output title'),
               name: 'create-plan',
               enabled: false,
               completed: false,
            }
         ],
         'saved': [
            {
               index: 0,
               journey: 'saved',
               title: i18n('label:saved-plan title'),
               name: 'saved-plan',
               enabled: true,
               completed: false,
            },
            {
               index: 1,
               journey: 'saved',
               title: i18n('label:review-preferences title'),
               name: 'review-preferences',
               enabled: false,
               completed: false,
            },
            {
               index: 2,
               journey: 'saved',
               title: i18n('label:review-units title'),
               name: 'review-units',
               enabled: false,
               completed: false,
            },
            {
               index: 3,
               journey: 'saved',
               title: i18n('label:course-output title'),
               name: 'create-new-plan',
               enabled: false,
               completed: false,
            }
         ]
      },
      currentJourney: 'default',
      currentStepIndex: 0
   }
}

const getters = {
   getJourney: state => name => {
      return state.currentJourney
   },

   // returns a single step
   getStep: state => index => {
      if (getters.inRange(index)) {
         return state.journey[state.currentJourney].find(step => step.index === index);
      }
   },
   // returns a single step by name
   getStepByName: state => name => {
      for(var journey in state.journey)
      {
         var step = state.journey[journey].find(step => step.name === name);
         if (step != null)
            return step;
      }
      return null;
   },

   // returns all the steps
   getSteps: state => state.journey[state.currentJourney],
   // returns the step which is the current step
   getCurrentStep: state => state.journey[state.currentJourney][state.currentStepIndex],

   // returns the step index which is the current step
   getCurrentStepIndex: state => state.currentStepIndex,

   // returns the journey name which is the current journey
   getCurrentJourney: state => state.currentJourney,

   getStepCompletion: state => index => Object.values(state.journey[state.currentJourney])[index].completed,
   getStepEnabled: state => index => Object.values(state.journey[state.currentJourney])[index].enabled,
   // returns the number of steps
   getStepsLength: state => state.journey[state.currentJourney].length,
   // returns on array of paths
   getPaths: state => state.journey[state.currentJourney].map(step => step.path)
}

const mutations = {
   setStepInvalidate(state) {
      if (state.currentJourney != undefined && state.currentStepIndex != undefined)
      {
         const currentJourneySteps =  Object.values(state.journey[state.currentJourney])
         const newSelectionObj = Object.values(getNewStateObj().journey[state.currentJourney])
         for(let i=state.currentStepIndex+1; i<state.journey[state.currentJourney].length;i++){
            Object.assign(currentJourneySteps[i], newSelectionObj[i])
         }
         currentJourneySteps[state.currentStepIndex].enabled = true
      }
   },
   // set step index
   setCurrentStepIndex(state, index) {
      state.currentStepIndex = index
   },

   // set step index
   setCurrentJourney(state, journey) {
      state.currentJourney = journey
   },
   // set step completion
   setStepCompletion(state, {index, completed}) {
      if (index < state.journey[state.currentJourney].length) {
         state.journey[state.currentJourney][index].completed = completed;
      }
   },
   // set step enabled
   setStepEnabled(state, {index, enabled}) {
      if (index < state.journey[state.currentJourney].length) {
         state.journey[state.currentJourney][index].enabled = enabled;
      }
   },


   resetState: (state) => {
      Object.assign(state, getNewStateObj())
   }
}

const actions = {

   goToSelectCourse({state}) {
      this.$app.$router.replace({ name: state.journey['default'][0].name })
   },

   setStepInvalidate({commit}) {
      commit('setStepInvalidate')
   },

   // helper to go to the next step
   nextStep({state, commit}) {
      // set current step completion to true
      commit('setStepCompletion', { index: state.currentStepIndex, completed: true })

      if (state.currentStepIndex > state.journey[state.currentJourney].length){
         throw 'Invalid step number'
      }
      const newStepIndex = state.currentStepIndex + 1
      // enable next step
      commit('setCurrentStepIndex', newStepIndex)
      commit('setStepEnabled', { index: newStepIndex, enabled: true })
      this.$app.$router.push({ name: state.journey[state.currentJourney][newStepIndex].name })
   },
   // helper to go to previous step
   previousStep({ state, commit, getters }, index=1) {
      if (state.currentStepIndex > 0) {
         // go to the previous step
         const negIndex = ~index + 1 //turns index => -index
         const newStepIndex = getters.getCurrentStepIndex + negIndex
         commit('setCurrentStepIndex', newStepIndex)
         this.$app.$router.push({ name: state.journey[state.currentJourney][newStepIndex].name })
      }
   },
   // helper to go to a specific step
   goToStep({ state, dispatch, getters}, index) {

      for (let i=0; i < index; i++){
         if(!getters.getStepCompletion(i)) {
            throw 'attempting to skip uncompleted steps'
         }
         if(!getters.getStepEnabled(i)) {
            throw 'attempting to skip disabled steps'
         }
      }
      // activate the selected index
      if (index < getters.getCurrentStepIndex) {
         dispatch('previousStep', getters.getCurrentStepIndex - index)
      }
      else {
         dispatch('nextStep', index - getters.getCurrentStepIndex)
      }
   },

   // helper to reset the whole user journey
   reset({commit}) {
      store.commit('courses/resetState')
      store.commit('preferences/resetState')
      store.commit('units/resetState')
      store.commit('plans/resetState')
      store.commit('savedCourse/resetState')
      commit('resetState')
   },

   // So, this is a dummy function used to trigger an Event, for one component to trigger an event to view the unit in another.
   // TODO: Can we do this without using Store events?
   viewUnit(context, { relationship, location }) {

   }
}

export default {
   namespaced: true,
   state: getNewStateObj(),
   getters,
   actions,
   mutations,
   getNewStateObj
}
